import React from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import image from "../images/cover4.jpg";
import SectionWrapper from "./SectionWrapper";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  minHeight: 120,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const Contact: React.FC = () => {
  return (
    <SectionWrapper name="contact" bg={undefined} minHeight="70vh">
      <Grid container spacing={{ xs: 2, sm: 4 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography
              variant="h3"
              component="div"
              gutterBottom
              sx={{
                fontSize: {
                  xs: "1.5rem",
                  sm: "2rem",
                  md: "2.5rem",
                },
              }}
            >
              Kontakt
            </Typography>
            <Box
              sx={{
                p: { xs: 2, sm: 5 },
                borderRadius: 2,
                bgcolor: "background.default",
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2,
                flexDirection: "column"
              }}
            >
              <Item key={1} elevation={1} >
                  Email: <br />
                <a href="mailto:jobb@båallservice.se">
                  jobb@båallservice.se
                </a>
              </Item>
              <Item key={2} elevation={1}>
                  Telefon: <br /> 
                <a href="tel:0766400493">
                  0766-40 04 93
                </a>
              </Item>
              {/* <Item key={4} elevation={1}>
                Org-nummer: <br /> ABCD123
              </Item> */}
            </Box>
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
            <img
              src={image}
              alt="This is a closeup of the owner"
              style={{
                width: "100%",
                maxHeight: "60vh",
                objectFit: "cover",
              }}
            />
        </Grid>
      </Grid>
    </SectionWrapper>
  );
};

export default Contact;
